
import { PositionInOrder } from '../../../../enums';
import StyleClassNamesBuilder from '../../../../styles/helpers/StyleClassNamesBuilder';
import GridBodyRowCellFactory from './factories/body-row-cell-factory';
import { GridSizeStylesProps } from '../../mixins/grid-size-styles';

export default {
  name: 'GridBodyRow',
  components: {
    GridBodyRowCellFactory,
  },
  mixins: [GridSizeStylesProps],
  props: {
    row: {
      default: () => {},
      type: Object,
    },
    rowIndex: {
      required: true,
      type: Number,
    },
    columns: {
      default: () => [],
      type: Array,
    },
    positionInOrder: {
      required: true,
      type: String,
    },
    stickyPositions: {
      default: () => [],
      type: Array,
    },
  },
  computed: {
    rowClassNames() {
      return new StyleClassNamesBuilder('grid-body-row')
        .addConditionClassNames(Object.values(PositionInOrder), this.positionInOrder)
        .build();
    },
  },
  methods: {
    getCellData(columnKey) {
      return this.row[columnKey];
    },
    getCellKey(cellIndex) {
      return `${this.rowIndex}-${cellIndex}`;
    },
  },
};
